import apiProxy from './api-proxy-inst';

class UserApi {
  UserList(args) {
    return apiProxy.request('/user/list', args).then(data => {
      return data;
    });
  }

  UserCount(args) {
    return apiProxy.request('/user/count', args).then(data => {
      return data;
    });
  }

  UserEndisable(args) {
    return apiProxy.request('/user_info/enDisable', args).then(data => {
      return data;
    });
  }

  getUserInfo(args) {
    return apiProxy.request('/user/getUserinfo', args).then(data => {
      return data;
    });
  }

  getCountry (args) {
    return apiProxy.requestPublic('/country/list', args).then(data => {
      return data;
    });
  }

  UserInfoChange(args) {
    return apiProxy.request('/cur_user_info/change', args).then(data => {
      return data;
    });
  }

  UserPasswordChange(args) {
    return apiProxy.request('/cur_user_password/change', args).then(data => {
      return data;
    });
  }
}

export default new UserApi();